module.exports = __webpack_public_path__ + "img/inner.f706764b.png";